export class IframeDimensions {
   private static readonly zero = new IframeDimensions(0, 0);

   public constructor(public width: number, public height: number) {
      // nothing to do
   }

   public isZeroSize(): boolean {
      return this.equals(IframeDimensions.zero);
   }

   public equals(other: IframeDimensions): boolean {
      return this.width === other.width && this.height === other.height;
   }
}
